/* card/types */
import * as t from "io-ts";

function tOptional<T extends t.Mixed>(typeThing: T) {
  return t.union([t.undefined, t.null, typeThing]);
}
const tId = t.union([t.undefined, t.null, t.string]);

export const KeyCodec = t.intersection([
  t.type({}),
  t.partial({
    Name: t.string,
    Value: t.string,
  }),
]);

export const FloorLimitCodec = t.intersection([
  t.type({}),
  t.partial({
    Name: t.string,
    Value: t.number,
  }),
]);

const ErrorCodec = t.type(
  {
    code: t.string,
    detail: t.string,
    title: t.string,
  },
  "ErrorCodec"
);

export const BinCodec = t.intersection([
  t.type({
    Account: t.array(t.string),
    From: t.string,
    To: t.string,
    Length: t.number,
  }),
  t.partial({
    Keys: t.array(KeyCodec),
    FloorLimit: t.array(FloorLimitCodec),
    CardType: t.string,
    AmountFrom: t.number,
    AmountTo: t.number,
    IsBinBlocked: t.boolean,
  }),
]);

const CardBinCodec = t.intersection([
  t.type({
    DescLong: t.string,
    DescShort: t.string,
    DUKPT: t.boolean,
    TippingEnabled: t.boolean,
    PINBlock: t.string,
    Bin: t.array(BinCodec),
  }),
  t.partial({}),
]);

export type CardBin = t.TypeOf<typeof CardBinCodec>;

export type Bin = t.TypeOf<typeof BinCodec>;

const AttributeCodec = t.intersection([
  t.type({
    Name: t.string,
  }),
  t.partial({
    CardBin: t.array(CardBinCodec),
  }),
]);

export const DataCodec = t.intersection([
  t.type({
    id: tId,
    type: t.string,
    attributes: AttributeCodec,
  }),
  t.partial({
    createdAt: t.string,
    updatedAt: t.string,
  }),
]);

export type Data = t.TypeOf<typeof DataCodec>;

export const CardCodec = t.type(
  {
    errors: tOptional(t.union([t.undefined, t.array(ErrorCodec)])),
    data: tOptional(t.array(DataCodec)),
  },
  "CardCodec"
);

export type Card = t.TypeOf<typeof CardCodec>;

export enum CardActionTypes {
  FETCH = "@@card/FETCH",
  FETCH_SUCCESS = "@@card/FETCH_SUCCESS",
  FETCH_ERROR = "@@card/FETCH_ERROR",
  SAVE_REQUEST = "@@card/SAVE_REQUEST",
  SAVE_SUCCESS = "@@card/SAVE_SUCCESS",
  SAVE_ERROR = "@@card/SAVE_ERROR",
  DELETE_REQUEST = "@@card/DELETE_REQUEST",
  DELETE_SUCCESS = "@@card/DELETE_SUCCESS",
  DELETE_ERROR = "@@card/DELETE_ERROR",
}

export interface CardState {
  readonly loading: boolean;
  readonly data: Card | undefined;
  readonly errors?: string;
}
